module.exports = __webpack_public_path__ + "img/portfolio-screenshot.bb18142c.jpg";